<template>
  <div
    class="custom-pill text-white"
    :style="{ backgroundColor: itemEnum.color, minWidth: `${width}px` }"
    :class="{bgColor : status === 'پیام از سمت کاربر'}"
  >
    <span>
      {{ itemEnum.title }}
    </span>
    <feather-icon
      v-if="itemEnum.icon"
      :icon="itemEnum.icon"
    />
  </div>
</template>

<script>
import i18n from '@/libs/i18n'

export default {
  name: 'PillCell',
  props: {
    status: {
      type: String,
      default: 'askedByUser',
    },
    width: {
      type: [String, Number],
      default: 100,
    },
  },
  computed: {
    itemEnum() {
      return {
        title: this.status,
        icon:
          this.status === i18n.t('articles.Published')
            ? 'PrinterIcon'
            : 'EditIcon',
        color: this.status === i18n.t('articles.Published') ? 'green' : 'grey',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-pill {
  color: #6e6b7b;
  background: transparent;
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  border-radius: 5px;
  padding: 5px;
  flex-wrap: nowrap;
  svg {
    margin-right: 10px;
  }
}
.bgColor{
  background:orange !important;
}
</style>
